<template>
    <div @click="goBack" :class="classes" class="cursor-pointer">
        go back
    </div>
</template>
<script setup>
import { defineProps, toRefs } from 'vue';
import i18n from '@/i18n/index'
import { useGlobal } from "@/composables/global/useGlobal";
const { goBack } = useGlobal();

const props = defineProps({
    classes: String,
});
let { classes } = toRefs(props);

</script>